"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _amplitude = _interopRequireDefault(require("./amplitude"));
var _anonymous = require("./anonymous");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var AmplitudeSubscriberSingleton = function () {
  var smAmplitude = null;
  return function (digitalDataEvent, metricsTrackerConfig) {
    if (metricsTrackerConfig.forceAnonymous) {
      // Call track() for anonymous users (no need to initialize)
      (0, _anonymous.anonymousTrack)(metricsTrackerConfig, digitalDataEvent);
    } else {
      // Initialize (if needed) and then track for regular, non anonymous users
      if (!smAmplitude) {
        smAmplitude = new _amplitude.default(metricsTrackerConfig);
      }
      smAmplitude.track(digitalDataEvent);
    }
  };
}();
var _default = exports.default = AmplitudeSubscriberSingleton;
module.exports = exports.default;